export default "__VITE_ASSET__DyLJcLOO__"